var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.resolveLayout,{tag:"component"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1),_c('demo-banner'),_c('vue-progress-bar'),_c('notifications',{attrs:{"position":"bottom","right":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }